<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import Jefe from "../../views/evaluaciones/evaluacion-jefedepartamento";
import Profesor from "../../views/evaluaciones/evaluacion-profesorjefe";
import Encargado from "../../views/evaluaciones/evaluacion-encargadoconvivencia";
import Docente from "../../views/evaluaciones/evaluacion-docente";
import Coordinador from "../../views/evaluaciones/evaluacion-coordinadoracademico";
import Auxiliar from "../../views/evaluaciones/evaluacion-auxiliar";
import Asistente from "../../views/evaluaciones/evaluacion-asistenteeducacion";


/**
 * Starter component
 */
export default {
    components: { Layout, PageHeader,Jefe, Profesor, Encargado, Docente, Coordinador, Auxiliar, Asistente},
    props:[
        'user_evaluar',
        'instrumento',
        'tipo_ev'
    ],
    data() {
        return {
            title: "",
            items: [
                {
                text: "Utility",
                href: "/"
                },
                {
                text: "Starter Page",
                active: true
                }
            ]
        };
    },
    created(){
        if (this.user.id==this.user_evaluar.id) {
            this.title="Autoevaluación"
        }else{
            this.title="Evaluación "+this.user_evaluar.nombre+' '+this.user_evaluar.apellidoPaterno+' '+this.user_evaluar.apellidoMaterno
        }
    }
};
</script>
<template>
    <Layout>
        <PageHeader  :items="items" />
        
        <Jefe :user_evaluar="user_evaluar" :tipo_ev="tipo_ev"  v-if="instrumento.nombre=='Jefe de Departamento'" :retro='false'/>
        <Profesor :user_evaluar="user_evaluar" :tipo_ev="tipo_ev" v-else-if="instrumento.nombre=='Profesor Jefe'" :retro='false'/>
        <Encargado :user_evaluar="user_evaluar" :tipo_ev="tipo_ev" v-else-if="instrumento.nombre=='Encargado de Convivencia'" :retro='false'/>
        <Docente :user_evaluar="user_evaluar" :tipo_ev="tipo_ev" v-else-if="instrumento.nombre=='Docente'" :retro='false'/>
        <Coordinador :user_evaluar="user_evaluar" :tipo_ev="tipo_ev" v-else-if="instrumento.nombre=='Coordinadores'" :retro='false'/>
        <Auxiliar :user_evaluar="user_evaluar" :tipo_ev="tipo_ev" v-else-if="instrumento.nombre=='Auxiliar'" :retro='false'/>
        <Asistente :user_evaluar="user_evaluar" :tipo_ev="tipo_ev" v-else-if="instrumento.nombre=='Asistente de la Educación'" :retro='false'/>
        <div v-else>
            {{instrumento}}
        </div>
    </Layout>
</template>